module.exports = __webpack_public_path__ + "img/star-gate.cf65386b.svg";